
export default {
	name: 'RightButtons',
	props: {
		/** 数组顺序由上层业务控制 */
		buttons: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			open: false
		}
	},
	computed: {
		isOver3Buttons() {
			return this.buttons.length > 3
		},
		/** 前三个是展示出来的 */
		normalList() {
			if (!this.isOver3Buttons) return this.buttons
			return this.buttons.slice(0, 3)
		},
		/** 后面的被收在更多按钮里面 */
		collapseList() {
			if (!this.isOver3Buttons) return []
			return this.buttons.slice(3)
		}
	},
	methods: {
		handleVisibleChange(val) {
			this.open = val
		},
		handleCommand(command) {
			const item = this.collapseList[command]
			item?.handler?.()
		}
	},
	mounted() {
		console.log('RightButtons mounted with buttons:', this.buttons)
	}
}
